import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';  // make sure react-router-dom is installed
import './home.css';
import kalki1 from "../Home/kalki1.jpg";

function Home() {
  const [soundEnabled, setSoundEnabled] = useState(false);

  useEffect(() => {
    const loadGoogleTranslate = () => {
      if (!window.googleTranslateElementInit) {
        window.googleTranslateElementInit = function () {
          new window.google.translate.TranslateElement(
            { pageLanguage: 'en' },
            'google_translate_element'
          );
        };

        const scriptId = 'google-translate-script';
        let script = document.getElementById(scriptId);

        if (!script) {
          script = document.createElement('script');
          script.id = scriptId;
          script.type = 'text/javascript';
          script.src = '//translate.google.com/translate_a/element.js?cb=googleTranslateElementInit';
          script.async = true;
          document.body.appendChild(script);
        } else {
          window.googleTranslateElementInit();
        }
      } else {
        window.googleTranslateElementInit();
      }
    };

    loadGoogleTranslate();
  }, []);

  useEffect(() => {
    if (soundEnabled) {
      const message = new SpeechSynthesisUtterance("Welcome to our homepage!");
      window.speechSynthesis.speak(message);
    }
  }, [soundEnabled]);

  return (
    <div className="home-container">
      <div className="voice-control">
        <div id="google_translate_element"></div>
        <label className="sound-toggle">
          <input
            type="checkbox"
            checked={soundEnabled}
            onChange={() => setSoundEnabled(!soundEnabled)}
          />
          🔊 Voice
        </label>
      </div>

      <div className="upload-control">
        <a href="/upload-info" className="upload-link">Upload Info</a>
      </div>

      {/* ✅ Wallpaper image */}
      <div className="wallpaper-container">
        <img src={kalki1} alt="Wallpaper" className="wallpaper-image" />
      </div>

      {/* ✅ Scrollable Content */}
      <div className="content-section">
        <h1>Welcome to the Website</h1>

        {/* ✅ Scan Poster Button */}
        <Link to="/scanner" className="scan-button">📷 Scan QR</Link>
      </div>
    </div>
  );
}

export default Home;
